<template>
  <div class="page-box decision-box">
    <div class="decision-head">
      <div class="decision-head-left">地面运行起飞前故障决策</div>
      <div class="decision-head-right">
        <div class="decision-head-bt" @click="goTask">
          <img src="@/assets/images/yi.png" />历史记录
        </div>
        <div class="decision-head-bt active" @click="$router.push('/index')">
          <img src="@/assets/images/yi2.png" />回到首页
        </div>
      </div>
    </div>
    <div class="decision-page">
      <div class="decision-left active">
        <div class="malfunction-head">
          <div class="malfunction-head-laber">
            故障信息<span @click="clickCarousel()">查看故障照片/信息 ></span>
          </div>
          <div class="malfunction-head-p">
            {{ checkNull(errorDetail, "fullFaultMessage") }}
          </div>
        </div>
        <div class="malfunction-page">
          <iframe
            ref="iframeMEL"
            :src="checkNull(errorDetail, 'html')"
            style="width: 100%;height: 710px"
            @load="iframeOnLoad"
          />
        </div>
      </div>
      <div class="decision-right">
        <div class="malfunction-top">
          <div class="malfunction-top-li">
            <div class="malfunction-top-h">
              {{ checkNull(errorDetail, "planeType") }}
            </div>
            <div class="malfunction-top-p">飞机类别</div>
          </div>
          <div class="malfunction-top-li">
            <div class="malfunction-top-h">
              {{ checkNull(errorDetail, "flightNo") }}
            </div>
            <div class="malfunction-top-p">航班号</div>
          </div>
          <div class="malfunction-top-li">
            <div class="malfunction-top-h">
              {{ checkNull(errorDetail, "planeId") }}/{{
                checkNull(errorDetail, "msn")
              }}
            </div>
            <div class="malfunction-top-p">注册号/MSN编号</div>
          </div>
        </div>
        <div class="malfunction-center">
          <div class="malfunction-left">
            <img
              v-show="checkNull(errorDetail, 'lastResult') === 'R2'"
              src="@/assets/images/btt1.png"
              @click="showConclusion('R2')"
            />
            <img
              v-show="checkNull(errorDetail, 'lastResult') === 'R3'"
              src="@/assets/images/btt2.png"
              @click="showConclusion('R3')"
            />
            <img
              v-show="checkNull(errorDetail, 'lastResult') === 'R1'"
              src="@/assets/images/btt3.png"
              @click="showConclusion('R1')"
            />
            <img
              v-show="checkNull(errorDetail, 'lastResult') === 'R4'"
              src="@/assets/images/btt4.png"
              @click="showConclusion('R4')"
            />
          </div>
          <div class="malfunction-right">
            <div class="malfunction-right-h">{{ remindTimeShow }}</div>
            <div
              class="malfunction-right-p"
              v-show="checkNull(errorDetail, 'lastResult') === 'R3'"
            >
              请在倒计时结束前决策
            </div>
            <div
              class="malfunction-right-p"
              v-show="checkNull(errorDetail, 'lastResult') !== 'R3'"
            >
              本次决策用时
            </div>
          </div>
        </div>
        <div class="malfunction-bottom">
          <div class="malfunction-navBox">
            <div
              class="malfunction-nav"
              @click="tabClick(0)"
              :class="{ active: tab == 0 }"
            >
              <span
                :style="
                  `width: 12px;height: 12px;background: ${resultColor(
                    pilotHandDetail
                  )};border-radius: 6px;margin-right: 5px`
                "
              />PILOT
            </div>
            <div
              class="malfunction-nav"
              @click="tabClick(1)"
              :class="{ active: tab == 1 }"
            >
              <span
                :style="
                  `width: 12px;height: 12px;background: ${resultColor(
                    socHandDetail
                  )};border-radius: 6px;margin-right: 5px`
                "
              />SOC
            </div>
            <div
              class="malfunction-nav"
              @click="tabClick(2)"
              :class="{ active: tab == 2 }"
            >
              <span
                :style="
                  `width: 12px;height: 12px;background: ${resultColor(
                    mechHandDetail
                  )};border-radius: 6px;margin-right: 5px`
                "
              />MECH
            </div>
          </div>
          <div class="communicate-box">
            <div>
              <div class="soc-box" :class="{ hide: tab != 0 }">
                <!--  <div class="pilot-box">开启第三方沟通页面</div>-->
                <div class="soc-li">
                  <div class="soc-top">
                    <div class="soc-left">1.是否有O程序？</div>
                    <div class="soc-right">
                      <el-radio
                        v-model="pilotHandDetail.pilotQuestionOne"
                        :label="true"
                        @click.native.prevent
                        >是
                      </el-radio>
                      <el-radio
                        v-model="pilotHandDetail.pilotQuestionOne"
                        :label="false"
                        @click.native.prevent
                        >否
                      </el-radio>
                    </div>
                  </div>
                  <div
                    class="soc-bottom"
                    v-show="pilotHandDetail.pilotQuestionOne"
                  >
                    <div class="soc-left">是否等效执行O程序？</div>
                    <div class="soc-right">
                      <el-radio
                        v-model="pilotHandDetail.pilotQuestionOneMore"
                        :label="true"
                        @click.native.prevent
                        >是
                      </el-radio>
                      <el-radio
                        v-model="pilotHandDetail.pilotQuestionOneMore"
                        :label="false"
                        @click.native.prevent
                        >否
                      </el-radio>
                    </div>
                  </div>
                </div>
                <div class="soc-li">
                  <div class="soc-top">
                    <div class="soc-left">
                      2.携带故障运行队飞机操作点印象是否能接受？
                    </div>
                    <div class="soc-right">
                      <el-radio
                        v-model="pilotHandDetail.pilotQuestionSecond"
                        :label="true"
                        @click.native.prevent
                        >是
                      </el-radio>
                      <el-radio
                        v-model="pilotHandDetail.pilotQuestionSecond"
                        :label="false"
                        @click.native.prevent
                        >否
                      </el-radio>
                    </div>
                  </div>
                </div>
                <div class="soc-li">
                  <div class="soc-top">
                    <div class="soc-left">3.注意事项相关要求是否满足？</div>
                    <div class="soc-right">
                      <el-radio
                        v-model="pilotHandDetail.pilotQuestionThird"
                        :label="true"
                        @click.native.prevent
                        >是
                      </el-radio>
                      <el-radio
                        v-model="pilotHandDetail.pilotQuestionThird"
                        :label="false"
                        @click.native.prevent
                        >否
                      </el-radio>
                    </div>
                  </div>
                  <div
                    class="soc-bottom"
                    v-show="
                      pilotHandDetail.pilotQuestionThird !== undefined &&
                        !pilotHandDetail.pilotQuestionThird
                    "
                  >
                    <el-select v-model="pilotHandDetail.pilotQuestionThirdMore">
                      <el-option value="QA0" label="机组资质不满足" disabled />
                      <el-option value="QA1" label="必要设备不满足" disabled />
                      <el-option value="QA2" label="运行环境不达标" disabled />
                      <el-option value="QA3" label="其他" disabled />
                    </el-select>
                  </div>
                  <el-input
                    v-show="pilotHandDetail.pilotQuestionThirdMore === 'QA3'"
                    type="textarea"
                    v-model="pilotHandDetail.pilotQuestionThirdMoreComment"
                    placeholder="请输入原因"
                    readonly
                  ></el-input>
                </div>
              </div>
            </div>
            <div>
              <div
                class="soc-box"
                :class="{ hide: tab != 1 }"
                :style="noclick()"
              >
                <div class="soc-li">
                  <div class="soc-top">
                    <div class="soc-left">1.是否有O程序？</div>
                    <div class="soc-right">
                      <el-radio
                        v-model="socHandDetail.socQuestionOne"
                        :label="true"
                        >是</el-radio
                      >
                      <el-radio
                        v-model="socHandDetail.socQuestionOne"
                        :label="false"
                        @input="
                          clearField(socHandDetail, ['socQuestionOneMore'])
                        "
                        >否</el-radio
                      >
                    </div>
                  </div>
                  <div class="soc-bottom" v-show="socHandDetail.socQuestionOne">
                    <div class="soc-left">是否等效执行O程序？</div>
                    <div class="soc-right">
                      <el-radio
                        v-model="socHandDetail.socQuestionOneMore"
                        :label="true"
                        >是</el-radio
                      >
                      <el-radio
                        v-model="socHandDetail.socQuestionOneMore"
                        :label="false"
                        >否</el-radio
                      >
                    </div>
                  </div>
                </div>
                <div class="soc-li">
                  <div class="soc-top">
                    <div class="soc-left">2.注意事项相关要求是否满足？</div>
                    <div class="soc-right">
                      <el-radio
                        v-model="socHandDetail.socQuestionSecond"
                        :label="true"
                        @input="
                          clearField(socHandDetail, [
                            'socQuestionSecondMoreComment',
                            'socQuestionSecondMore'
                          ])
                        "
                      >
                        是
                      </el-radio>
                      <el-radio
                        v-model="socHandDetail.socQuestionSecond"
                        :label="false"
                        >否</el-radio
                      >
                    </div>
                  </div>
                  <div
                    class="soc-bottom"
                    v-show="
                      socHandDetail.socQuestionSecond !== undefined &&
                        !socHandDetail.socQuestionSecond
                    "
                  >
                    <el-select v-model="socHandDetail.socQuestionSecondMore">
                      <el-option value="QA0" label="机组资质不满足" />
                      <el-option value="QA1" label="必要设备不满足" />
                      <el-option value="QA2" label="运行环境不达标" />
                      <el-option value="QA3" label="其他" />
                    </el-select>
                  </div>
                  <el-input
                    v-show="socHandDetail.socQuestionSecondMore === 'QA3'"
                    type="textarea"
                    v-model="socHandDetail.socQuestionSecondMoreComment"
                    placeholder="请输入原因"
                    :maxlength="255"
                  ></el-input>
                </div>
                <div class="bt pb" @click="addRecordHandle" :style="noclick1()">
                  提交
                </div>
              </div>
            </div>
            <div>
              <div class="soc-box" :class="{ hide: tab != 2 }">
                <div class="soc-li">
                  <div class="soc-top">
                    <div class="soc-left">1.是否有M程序？</div>
                    <div class="soc-right">
                      <el-radio
                        v-model="mechHandDetail.mechQuestionOne"
                        :label="true"
                        @click.native.prevent
                        >是
                      </el-radio>
                      <el-radio
                        v-model="mechHandDetail.mechQuestionOne"
                        :label="false"
                        @click.native.prevent
                        >否
                      </el-radio>
                    </div>
                  </div>
                  <div
                    class="soc-bottom"
                    v-show="mechHandDetail.mechQuestionOne"
                  >
                    <div class="soc-left">是否等效执行O程序？</div>
                    <div class="soc-right">
                      <el-radio
                        v-model="mechHandDetail.mechQuestionOneMore"
                        :label="true"
                        @click.native.prevent
                        >是
                      </el-radio>
                      <el-radio
                        v-model="mechHandDetail.mechQuestionOneMore"
                        :label="false"
                        @click.native.prevent
                        >否
                      </el-radio>
                    </div>
                  </div>
                </div>
                <div class="soc-li">
                  <div class="soc-top">
                    <div class="soc-left">2.修理时限要求能否接受？</div>
                    <div class="soc-right">
                      <el-radio
                        v-model="mechHandDetail.mechQuestionSecond"
                        :label="true"
                        @click.native.prevent
                        >是
                      </el-radio>
                      <el-radio
                        v-model="mechHandDetail.mechQuestionSecond"
                        :label="false"
                        @click.native.prevent
                        >否
                      </el-radio>
                    </div>
                  </div>
                </div>
                <div class="soc-li">
                  <div class="soc-top">
                    <div class="soc-left">
                      3.目的地机场是否有机务人员办理相关MEL？
                    </div>
                    <div class="soc-right">
                      <el-radio
                        v-model="mechHandDetail.mechQuestionThird"
                        :label="true"
                        @click.native.prevent
                        >是
                      </el-radio>
                      <el-radio
                        v-model="mechHandDetail.mechQuestionThird"
                        :label="false"
                        @click.native.prevent
                        >否
                      </el-radio>
                    </div>
                  </div>
                </div>
                <div class="soc-li">
                  <div class="soc-top">
                    <div class="soc-left">
                      4.目的地机场必要设备能否保障（外部电源，气源）？
                    </div>
                    <div class="soc-right">
                      <el-radio
                        v-model="mechHandDetail.mechQuestionFour"
                        :label="true"
                        @click.native.prevent
                        >是
                      </el-radio>
                      <el-radio
                        v-model="mechHandDetail.mechQuestionFour"
                        :label="false"
                        @click.native.prevent
                        >否
                      </el-radio>
                    </div>
                  </div>
                </div>
                <!--  <div class="bt pb" >提交</div>-->
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <finallys
      v-if="resultDailogFlag"
      :msg="resultComment"
      :reds="resultDailogFlag"
      @handle-close="handleClose"
      @ok="goTaskList"
    />
    <History
      v-if="isHistory"
      :dialogVisible="isHistory"
      client="ROLE_SOC"
      @handle-close="closeHistory"
    ></History>
    <hint
      v-if="hintDialog"
      :hintDialog="hintDialog"
      @handle-close="closeHint"
    ></hint>
    <Carousel
      v-if="carouselDialog"
      :showDialog="carouselDialog"
      @handle-close="closeCarousel"
      :imgs="imgs"
    ></Carousel>
    <!--最终决策-->
    <system
      v-if="systemDialog"
      :systemDialog="systemDialog"
      @handle-close="closeSystem"
      :msg="errorDetail"
    />
  </div>
</template>

<script>
import isUndefined from "lodash/isUndefined";
import isNull from "lodash/isNull";
import { addErrorRecordHandle, planeErrorDetail } from "@/api/api";
import History from "@/components/History";
import hint from "@/components/hint";
import Carousel from "@/components/Carousel";
import finallys from "@/components/finally";
import system from "@/components/system";
import MixinMqttClient from "@/components/mqtt/MixinMqttClient";

export default {
  name: "decision",
  components: { History, hint, Carousel, finallys, system },
  mixins: [MixinMqttClient],
  data() {
    return {
      tableData: [
        {
          date: "C",
          date2: "1",
          date3: "0",
          date4: "是"
        }
      ],
      active: 0,
      nav: 0,
      radio: "1",
      tab: 1,
      id: "",
      errorDetail: null,
      pilotHandDetail: {},
      mechHandDetail: {},
      socHandDetail: {
        socQuestionOne: null,
        socQuestionOneMore: null,
        socQuestionSecond: null,
        socQuestionSecondMore: null,
        socQuestionSecondMoreComment: null
      },
      remindTimeShow: "00:00",
      timeInterval: undefined,
      remindTime: 0,
      resultDailogFlag: false,
      resultComment: undefined,
      isHistory: false,
      hintDialog: false,
      carouselDialog: false,
      systemDialog: false,
      imgs: []
    };
  },
  //todo mel转成html   查看故障信息照片/重新选择缺失
  created() {
    this.id = this.$route.params.id;
    this.getPlaneErrorDetail().then(i => {
      if (this.remindTime > 0) {
        this.timeInterval = window.setInterval(() => {
          this.startInterval();
        }, 1000);
      }
    });
  },
  mounted() {
    this.subscribeTopic();
  },
  beforeDestroy() {
    clearInterval(this.timeInterval);
    if (this.topic) {
      this.unsubscribeMQTT(this.topic);
    }
  },
  computed: {
    enableMQTT() {
      if (this.disabledMQTT) {
        return false;
      }

      if (
        isNull(this.errorDetail) ||
        isUndefined(this.errorDetail.done) ||
        isNull(this.errorDetail.done)
      ) {
        return false;
      }
      if (this.errorDetail.done) {
        return false;
      }
      if (!this.id) {
        return false;
      }
      return true;
    },
    topic() {
      return this.enableMQTT ? `PlaneErrorRecordService/${this.id}` : "";
    }
  },
  watch: {
    enableMQTT(newValue){
      if (newValue) {
        this.subscribeTopic()
      } else if (this.topic) {
        this.unsubscribeMQTT(this.topic);
      }
    },
    topic(newValue, oldValue) {
      if (newValue) {
        this.subscribeTopic();
      } else if (oldValue) {
        this.unsubscribeMQTT(oldValue);
      }
    }
  },
  methods: {
    tabClick(e) {
      // console.log(e)
      this.tab = e;
    },
    async getPlaneErrorDetail() {
      const res = await planeErrorDetail({ id: this.id });
      if (res.code === "A00000") {
        this.errorDetail = res.data[0];
        if (
          this.errorDetail &&
          this.errorDetail.handleMap &&
          this.errorDetail.handleMap.ROLE_PILOT
        ) {
          this.pilotHandDetail = this.errorDetail.handleMap.ROLE_PILOT;
        }
        if (
          this.errorDetail &&
          this.errorDetail.handleMap &&
          this.errorDetail.handleMap.ROLE_SOC
        ) {
          this.socHandDetail = this.errorDetail.handleMap.ROLE_SOC;
        }
        if (
          this.errorDetail &&
          this.errorDetail.handleMap &&
          this.errorDetail.handleMap.ROLE_MECH
        ) {
          this.mechHandDetail = this.errorDetail.handleMap.ROLE_MECH;
        }
        this.iframeOnLoad();
        // console.log(['this.mechHandDetail', this.mechHandDetail])
        if (
          this.errorDetail &&
          this.errorDetail.lastResult &&
          this.errorDetail.lastResult === "R3"
        ) {
          if (this.errorDetail.systemResult !== "R3") {
            this.systemDialog = true;
          }
          var now = new Date().getTime();
          var seconds = new Date(this.errorDetail.createTimeFormat).getTime();
          //    var seconds1 = Date.parse(this.errorDetail.createTime).getSeconds();
          console.log(`now-->${now} 开始-->${seconds}  差值${now - seconds}`);
          if (now - seconds > 300000) {
            this.remindTime = 0;
          } else {
            this.remindTime = 300 - Math.floor((now - seconds) / 1000);
          }
        } else {
          this.remindTimeShow = this.errorDetail.compileTime;
        }
        // R1("起飞"),
        // R2("确认滑回"),
        // R3("等待"),
        // R4("公司决策"),
        // if (this.errorDetail && !this.errorDetail.done) {
        //   this.resultComment = this.errorDetail
        //   this.resultDailogFlag = true
        // }
      }
    },
    checkNull(obj, attr) {
      return attr && obj && obj[attr] ? obj[attr] : "";
    },
    startInterval() {
      this.remindTime -= 1;
      if (this.remindTime <= 0) {
        clearInterval(this.timeInterval);
        if (this.errorDetail && this.errorDetail.lastResult === "R3") {
          this.hintDialog = true;
          return;
        }
      }
      if (this.remindTime < 0) return;
      var m = Math.floor(this.remindTime / 60);
      var s = this.remindTime % 60;
      this.remindTimeShow = `0${m}:${s < 10 ? "0" + s : s}`;
    },
    async addRecordHandle() {
      this.socHandDetail.recordId = this.id;
      this.socHandDetail.flightNo = this.checkNull(
        this.errorDetail,
        "flightNo"
      );
      this.socHandDetail.remainTime = this.remindTimeShow.replace(":", "");
      if (!this.checkFiledAndWarn()) {
        this.$message.warning("请完成所有题目");
        return;
      }
      const res = await addErrorRecordHandle(this.socHandDetail);
      if (res.code === "A00000") {
        this.$message.success("提交决策成功");
        clearInterval(this.timeInterval);
      } else {
        this.$message.error(res.message);
      }
    },
    subscribeTopic() {
      if (this.enableMQTT && this.topic) {
        this.subscribeMQTT(this.topic, message => {
          this.onMessage(message);
        });
      }
    },
    onMessage(message) {
      if (message) {
        const res = JSON.parse(message.toString());
        this.getPlaneErrorDetail();
        if (res && res.result && res.result !== "R3") {
          this.resultComment = res;
          this.resultDailogFlag = true;
        }
      }
    },
    goTask() {
      this.isHistory = true;
    },
    goTaskList() {
      this.$router.push("/task/ROLE_SOC");
    },
    resultColor(item) {
      if (!(item && item.lastResult)) return "#EBA967";
      if (item.lastResult === "R1") {
        return "#8EBF86";
      } else if (item.lastResult === "R2") {
        return "#E07073";
      } else if (item.lastResult === "R3") {
        return "#EBA967";
      }
    },
    noclick() {
      return this.socHandDetail && this.socHandDetail.lastResult
        ? "pointer-events: none"
        : "";
    },
    noclick1() {
      return this.socHandDetail && this.socHandDetail.lastResult
        ? "background: darkgray"
        : "";
    },
    clearField(obj, array) {
      array.forEach(attr => {
        if (obj[attr] !== undefined) {
          obj[attr] = undefined;
        }
      });
    },
    checkFiledAndWarn() {
      if (
        this.socHandDetail.socQuestionOne !== undefined &&
        this.socHandDetail.socQuestionSecond !== undefined
      ) {
        if (
          this.socHandDetail.socQuestionOne &&
          this.socHandDetail.socQuestionOneMore === undefined
        ) {
          return false;
        }
        if (
          !this.socHandDetail.socQuestionSecond &&
          this.socHandDetail.socQuestionSecondMore === undefined
        ) {
          return false;
        }
        return !(
          this.socHandDetail.socQuestionSecondMore === "QA3" &&
          !this.socHandDetail.socQuestionSecondMoreComment
        );
      }
      return false;
    },
    handleClose() {
      this.resultDailogFlag = false;
    },
    closeHistory() {
      this.isHistory = false;
    },
    closeHint() {
      this.hintDialog = false;
    },
    closeCarousel() {
      this.carouselDialog = false;
    },
    closeSystem() {
      this.systemDialog = false;
    },
    clickCarousel() {
      this.imgs = this.errorDetail.errorImages
        ? this.errorDetail.errorImages
        : [];
      if (this.errorDetail.errorMedia) {
        this.errorDetail.errorMedia.forEach(media => {
          this.imgs.push(media);
        });
      }
      if (this.imgs.length === 0) {
        this.$message.warning("暂无故障照片/信息");
      }
      this.carouselDialog = this.imgs.length > 0;
    },
    showConclusion(type) {
      if (
        this.errorDetail &&
        this.errorDetail.done &&
        type === this.errorDetail.lastResult
      ) {
        this.resultComment = this.errorDetail;
        this.resultDailogFlag = true;
      }
    },
    iframeOnLoad() {
      console.log([
        "iframeOnLoad containsO",
        this.$refs.iframeMEL.contentWindow
      ]);
      if (this.$refs.iframeMEL.contentWindow.containsO) {
        // /home/nanhang/nfs/CSGenData/html
        // sed -i "s/'M'/'(M)'/g" ./*/*/*.html
        const containsO = this.$refs.iframeMEL.contentWindow.containsO();
        // console.log(['iframeOnLoad containsO', containsO])
        this.socHandDetail.socQuestionOne = containsO;
      } else {
        this.socHandDetail.socQuestionOne = false;
      }
      console.log([
        "socHandDetail.socQuestionOne",
        this.socHandDetail.socQuestionOne
      ]);
    }
  }
};
</script>

<style lang="less" scoped>
.soc-bottom {
  height: 46px !important;
}

/deep/ .el-select {
  width: 100%;

  .el-input__inner {
    background: #2f323d;
    border-radius: 8px;
    border: none;
    font-size: 16px;
  }
}

/deep/ .el-textarea textarea {
  background: #171821;
  border-radius: 8px;
  color: #fff;
  height: 80px;
  border: none;
  margin-top: 12px;
  padding: 10px 16px;
}

/deep/ .soc-bottom .el-input__inner {
  background: none;
  padding: 0;
}

/deep/ .el-table {
  margin-bottom: 15px;
}

/deep/ .el-radio {
  color: #fff;
}

/deep/ .el-table td.el-table__cell,
.el-table th.el-table__cell.is-leaf {
  background: #272833;
  border-bottom: 1px solid rgba(255, 255, 255, 0.6);
  border-right: 1px solid rgba(255, 255, 255, 0.6);
  color: rgba(255, 255, 255, 0.87);
  opacity: 0.87;
  text-align: center;
}

/deep/ .el-table td.el-table__cell:first-child {
  border-left: 1px solid rgba(255, 255, 255, 0.6);
  opacity: 0.87;
}

/deep/ .el-table tr {
  background: #272833;
}

/deep/
  .el-table--enable-row-hover
  .el-table__body
  tr:hover
  > td.el-table__cell {
  background: #171821;
}

/deep/ .el-table th.el-table__cell {
  background: #272833;
  border-bottom: 1px solid rgba(255, 255, 255, 0.6);
  border-right: 1px solid rgba(255, 255, 255, 0.6);
  border-top: 1px solid rgba(255, 255, 255, 0.6);
  color: rgba(255, 255, 255, 0.87);
  text-align: center;
  opacity: 0.87;
}

/deep/ .el-table th.el-table__cell:first-child {
  border-left: 1px solid rgba(255, 255, 255, 0.6);
}

/deep/ .el-table--border::after,
.el-table--group::after,
.el-table::before {
  display: none;
}
</style>



// WEBPACK FOOTER //
// src/views/malfunction/malfunction.vue